import React from 'react';
import PropTypes from 'prop-types';
import UserDatabases from '@Services/UserDatabases';

function ExportModalHeader(props) {
  const { parentParams } = props;
  const { context, databaseId } = parentParams;

  const showBioLabel = context === 'dpitems' || context === 'tgitems';
  const isDbNameVisible = UserDatabases.getAll().length > 1;
  const dbName = UserDatabases.getDbName(databaseId);

  return (
    <div className="exportModal__header">
      <h4>
        Export
        {!showBioLabel && (
          <>
            <span className="text-lowercase">{context}</span>
            {isDbNameVisible && <span>{dbName}</span>}
          </>
        )}
        {showBioLabel && <span className="text-lowercase">Substances and Bioactivities</span>}
      </h4>
    </div>
  );
}

ExportModalHeader.propTypes = {
  parentParams: PropTypes.object,
};

export default ExportModalHeader;
